const MIN_DISPLAY_SOLD_BOOST = 2;
const MAX_DISPLAY_SOLD_BOOST = 5;

function stableHash(value) {
  return String(value || "")
    .split("")
    .reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0)) | 0, 0);
}

export function getDisplaySoldCount(productOrCount) {
  const isProduct = productOrCount && typeof productOrCount === "object";
  const actualSold = Number(isProduct ? productOrCount.soldCount || 0 : productOrCount || 0);
  const safeActualSold = Number.isFinite(actualSold) ? Math.max(0, actualSold) : 0;
  const seed = isProduct
    ? productOrCount._id || productOrCount.id || productOrCount.sku || productOrCount.slug || productOrCount.name
    : String(safeActualSold);
  const range = MAX_DISPLAY_SOLD_BOOST - MIN_DISPLAY_SOLD_BOOST + 1;
  const boost = MIN_DISPLAY_SOLD_BOOST + (Math.abs(stableHash(seed)) % range);

  return safeActualSold + boost;
}
